import { InputRule } from 'prosemirror-inputrules';
import { NodeType } from 'prosemirror-model';
import { EditorState, TextSelection } from 'prosemirror-state';

export function horizontalLineRule(nodeType: NodeType) {
  return new InputRule(/---+$/, (state: EditorState, match, start, end) => {
    let tr = state.tr;
    tr = tr.replaceRangeWith(start, end, nodeType.create());
    tr = tr.setSelection(
      TextSelection.create(tr.doc, tr.selection.to, tr.selection.to),
    );
    return tr;
  });
}
